import { createSlice } from "@reduxjs/toolkit"

import { logout } from "../../LoginPage/redux/auth.actions"
import { BUSINESS_DETAILS_SLICE_NAME } from "./businessDetails.constants"
import { getBusinessDetails, getCountries, updateBusinessDetails } from "./businessDetails.thunks"

/* ------------- Initial State ------------- */

const initialState = {
  fetching: false,
  loaded: false,
  businessDetails: null,
  countries: []
}

const slice = createSlice({
  name: BUSINESS_DETAILS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* ---------------- business details ---------------- */
      .addCase(getBusinessDetails.pending, (state) => {
        state.fetching = true
      })
      .addCase(getBusinessDetails.fulfilled, (state, action) => {
        // The endpoint is a list endpoint that only ever returns the one record.
        state.fetching = false
        state.loaded = true
        state.businessDetails = action.payload?.results?.[0] ?? null
      })
      .addCase(getBusinessDetails.rejected, (state) => {
        state.fetching = false
        state.loaded = true
      })

      /* ---------------- update business details ---------------- */
      .addCase(updateBusinessDetails.pending, (state) => {
        state.fetching = true
      })
      .addCase(updateBusinessDetails.fulfilled, (state, action) => {
        state.fetching = false
        state.businessDetails = action.payload
      })
      .addCase(updateBusinessDetails.rejected, (state) => {
        state.fetching = false
      })

      /* ---------------- countries ---------------- */
      // The legacy reducer left `fetching` untouched for this request - the country list
      // loads behind the already-rendered form, so it never drove a spinner.
      .addCase(getCountries.fulfilled, (state, action) => {
        state.countries = action.payload
      })

      /* ---------------- logout ---------------- */
      .addCase(logout, () => initialState)
  }
})

// No `persistReducer` here: every field is either a transient flag or server data that is
// re-fetched on mount, so there is nothing worth restoring across a reload.
export const reducer = slice.reducer
